import { DraggableSyntheticListeners } from '@dnd-kit/core';
import React, { HTMLAttributes, memo } from 'react';

export interface SortHandleProps extends HTMLAttributes<HTMLDivElement> {
  listeners?: DraggableSyntheticListeners;
}

export const SortHandle = memo((props: SortHandleProps) => {
  const { listeners, ...rest } = props;
  return (
    <div {...listeners} {...rest}>
      {rest.children || <i className="fa fa-grip-vertical" style={{ cursor: 'move' }} />}
    </div>
  );
});
